import React from "react";
import { formatHours } from "../../utils/timecard";

export default function SectionHeading({ kicker, title, total, titleId }) {
  return (
    <div className="section-heading">
      <div>
        <span className="section-kicker">{kicker}</span>
        {title ? <h2 id={titleId}>{title}</h2> : null}
      </div>
      {typeof total === "number" ? (
        <span className="total-chip">{formatHours(total)}</span>
      ) : null}
    </div>
  );
}
